import axios from 'axios';

export const htmlId: string = 'order-confirmation';
export const maxWidthDragAndDropFile: number = 500;
export const minHeightDragAndDropFile: number = 50;
export const uploadFileInfo: string = 'UPLOAD_FILE_INFO';
export const extensionFiles: string[] = ['.pdf'];
export const pdfFileNameOrderSummary: string = 'CartDetails';

const prefix: string = 'Orders/';

export const submitOrders = () => {
    const languageCode = localStorage.getItem('lang');
    return axios.post(`${prefix}SubmitOrders?languageCode=${languageCode}`);
};

export const getPdfOrderSummary = () => {
    const languageCode = localStorage.getItem('lang');
    return axios.get(`${prefix}GetPdfOrderSummary?languageCode=${languageCode}`);
};
